import { create } from 'zustand';

type OverviewSessionUiState = {
  /**
   * Incremented to request clearing list UI state (search/sort/filter/pagination).
   * Useful when session roster changes due to Start/Continue flow.
   */
  resetNonce: number;
  /**
   * Incremented to request re-fetching the Overview Session roster.
   * Useful when navigating into OverviewSession or after editing a player.
   */
  refreshNonce: number;
};

type OverviewSessionUiActions = {
  requestReset: () => void;
  requestRefresh: () => void;
};

export const useOverviewSessionUiStore = create<OverviewSessionUiState & OverviewSessionUiActions>(
  set => ({
    resetNonce: 0,
    requestReset: () => set(s => ({ resetNonce: s.resetNonce + 1 })),
    refreshNonce: 0,
    requestRefresh: () => set(s => ({ refreshNonce: s.refreshNonce + 1 })),
  }),
);
